// Accent colors for avatar backgrounds
const AVATAR_COLORS = [
  '#8409D3',
  '#8D37A7', 
  '#C769EB',
  '#DD5BEA',
  '#E02CDC',
  '#9941B4',
  '#C769EB'
];

// Generate a consistent color for a username
export const getAvatarColor = (username: string): string => {
  if (!username) return AVATAR_COLORS[0];
  
  // Simple hash function to get consistent color for each username
  let hash = 0;
  for (let i = 0; i < username.length; i++) {
    hash = username.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  // Use absolute value and modulo to get index
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
};

// Generate avatar placeholder data
export const getAvatarPlaceholder = (username?: string) => {
  if (!username) return null;
  
  const firstLetter = username.charAt(0).toUpperCase();
  const backgroundColor = getAvatarColor(username);
  
  return {
    letter: firstLetter,
    color: backgroundColor
  };
};

// Generate a data URL for avatar placeholder
export const generateAvatarDataUrl = (username?: string): string | null => {
  if (!username) return null;
  
  const placeholder = getAvatarPlaceholder(username);
  if (!placeholder) return null;
  
  // Create a canvas to generate the avatar
  const canvas = document.createElement('canvas');
  const size = 100;
  canvas.width = size;
  canvas.height = size;
  
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;
  
  // Draw background circle
  ctx.fillStyle = placeholder.color;
  ctx.beginPath();
  ctx.arc(size / 2, size / 2, size / 2, 0, 2 * Math.PI);
  ctx.fill();
  
  // Draw letter
  ctx.fillStyle = 'white';
  ctx.font = `bold ${size * 0.4}px sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(placeholder.letter, size / 2, size / 2);
  
  return canvas.toDataURL('image/png');
};